///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { combineReducers } from "@reduxjs/toolkit";

import { activeBidsReducer } from "./slices/activeBidsSlice";
import { newBidReducer } from "./slices/newBidSlice";
import { userReducer } from "./slices/userSlice";
import { pendingBidsReducer } from "./slices/pendingBidsSlice";
import { bidSummaryReducer } from "./slices/bidSummarySlice";
import { searchAllBidsReducer } from "./slices/searchAllBidsSlice";
import { featureFlagsReducer } from "./slices/featureFlagsSlice";
import { appReducer } from "./slices/appSlice";
import { notificationsReducer } from "./slices/notificationsSlice";
import { bidDetailsReducer } from "./slices/bidDetailsSlice";
import { bidPricingReducer } from "./slices/bidPricingSlice";
import { laneMatchReducer } from "./slices/laneMatchSlice";
import { analyticsReducer } from "./slices/analyticsSlice";
import { bidProcurementReducer } from "./slices/bidProcurementSlice";
import { strategicQuantileReducer } from "./slices/strategicQuantileSlice";

const rootReducer = combineReducers({
  activeBids: activeBidsReducer,
  newBid: newBidReducer,
  user: userReducer,
  pendingBids: pendingBidsReducer,
  bidSummary: bidSummaryReducer,
  searchAllBids: searchAllBidsReducer,
  featureFlags: featureFlagsReducer,
  app: appReducer,
  notifications: notificationsReducer,
  bidDetails: bidDetailsReducer,
  bidPricing: bidPricingReducer,
  laneMatch: laneMatchReducer,
  analytics: analyticsReducer,
  bidProcurement: bidProcurementReducer,
  strategicQuantile: strategicQuantileReducer
});

export default rootReducer;
